/* global CallGuide */
/* eslint-disable import/no-cycle */
import config from '../../../../config'
import {
  CHAT_API_INITIALIZED,
  CHAT_CLEAR,
  CHAT_CLOSE_WARNING,
  CHAT_ENTRANCE_CLOSED,
  CHAT_FINISHED,
  CHAT_FORM_OPENED,
  CHAT_MESSAGE_SENT,
  CHAT_MINIMIZE,
  CHAT_NEW_MESSAGE,
  CHAT_PEN_STATE,
  CHAT_QUEUED,
  CHAT_REQUESTED,
  CHAT_STARTED,
  CHAT_SYSTEM_MESSAGE,
  CHAT_TOKEN,
  NOTIFY_DANGER,
} from './action-types'
import { request } from './auth-actions'
import { dismiss, notify } from './notification-actions'
import { ChatState } from '../../models/chat'
import authServiceApi from '../../api/auth-service-api'
import { genericError } from './action-utils'
import { chatEntrance } from '../../models/contactInformation'

//* ****************
// Util
//* ****************
const log = message => {
  // eslint-disable-next-line no-console
  console.log(message)
}

//* ****************
// Actions
//* ****************

const chatFormOpened = () => ({
  type: CHAT_FORM_OPENED,
})

const chatTokenSuccess = response => ({
  response,
  type: CHAT_TOKEN,
})

const chatRequestedSuccess = errand => ({
  errand,
  type: CHAT_REQUESTED,
})

export const chatStartedSuccess = agent => ({
  agent,
  type: CHAT_STARTED,
})

const newChatMessage = msg => ({
  msg,
  type: CHAT_NEW_MESSAGE,
})

export const minimize = (errandType, msg) => ({
  type: CHAT_MINIMIZE,
  errandType,
  msg,
})

const apiInitialized = () => ({
  type: CHAT_API_INITIALIZED,
})

const messageSent = () => ({
  type: CHAT_MESSAGE_SENT,
})

const systemMessage = msg => ({ msg, type: CHAT_SYSTEM_MESSAGE })

export const clear = msg => ({
  msg,
  type: CHAT_CLEAR,
})

export const chatQueued = info => ({ info, type: CHAT_QUEUED })

export const chatFinished = () => ({ type: CHAT_FINISHED })

export const chatEntranceClosed = () => ({ type: CHAT_ENTRANCE_CLOSED })

export const penStateChanged = state => ({ type: CHAT_PEN_STATE, state })

export const beforeCloseWaring = () => ({ type: CHAT_CLOSE_WARNING })

export const sendMessage = msg => dispatch => {
  CallGuide.api.chat.write(msg)
  dispatch(messageSent())
}

// requestLegacy callbacks
const showChat = () => {}

const hideChat = () => {}

const startChat = (entrance, errand, question, contactData, authToken) => {
  CallGuide.api.chat.request({
    entrance,
    errand,
    visitorQuestion: question,
    videoChatMode: 'disabled',
    clientId: 'resurs-merchant-portal',
    contactData,
    authToken,
  })
}

export const chatQuit = msg => (dispatch, getState) => {
  if (
    getState().chat.chatState !== ChatState.NONE &&
    typeof CallGuide !== 'undefined'
  ) {
    CallGuide.api.chat.quit()
    CallGuide.api.chat.delete()
  }
  dispatch(clear(msg))
}

export const initializeApi = () => (dispatch, getState) => {
  if (typeof CallGuide === 'undefined') {
    log('CallGuide API is undefined.')
    return
  }

  // API event callback functions
  const apiEventClear = () => {}
  const apiEventReady = () => {}

  /*
   startupObj = {infoText: string}
   */
  const apiEventStartup = () => {
    dispatch(chatQueued({ queuePos: 1 }))
  }

  /*
   queueObj = {infoText: string,
   queuePos: integer,
   eqt: integer}
   */
  const apiEventQueue = queueObj => {
    dispatch(
      chatQueued({ queuePos: queueObj.queuePos, estQueueTime: queueObj.eqt }),
    )
  }

  /*
   estObj = {
    infoText: string,
    agent: string
   }
   */
  const apiEventEstablished = estObj => {
    dispatch(chatStartedSuccess(estObj.agent))
  }

  /*
   queueObj = {infoText: string,
   queuePos: integer,
   eqt: integer}
   */
  const apiEventPlacedInQueue = queueObj => {
    dispatch(
      chatQueued({ queuePos: queueObj.queuePos, estQueueTime: queueObj.eqt }),
    )
  }

  /*
   afterObj = {infoText: string,
   emailAddress: string}
   */
  const apiEventAfterChat = () => {}

  /*
   finishedObj = {infoText: string}
   */
  const apiEventFinished = () => {
    dispatch(chatFinished())
  }

  /*
   errorObj = {
    infoText: string,
    reason: string
   }
   */
  const apiEventError = errorObj => {
    notify(NOTIFY_DANGER, errorObj.infoText)
  }

  /*
   entranceClosedObj = {infoText: string}
   */
  const apiEventEntranceClosed = () => {
    dispatch(chatEntranceClosed())
  }

  /*
   entryObj = {
    source: string, // The origin of the message, system, agent, or customer.
    timeStamp: string, // The time the message was written
    alias: string, // The nick for the source
    message: string
   }
   */
  const apiEventChatEntry = entryObj => {
    if (entryObj.source === 'system') {
      dispatch(systemMessage(entryObj.message))
    } else {
      const msg = {
        text: entryObj.message,
        timeStamp: entryObj.timeStamp,
        fromMe: entryObj.source === 'customer',
      }

      dispatch(newChatMessage(msg))
    }
  }

  /*
   configObj = {chatEntryMaxLength: integer}
   */
  const apiEventConfig = () => {}

  const apiEventMessageSent = () => {}

  /*
   penObj = {
   penStatus: string, // 'on' or 'off'
   alias: string // agents nickname
   }
   */
  const apiEventPenStatus = penStatusObj => {
    dispatch(penStateChanged(penStatusObj.penStatus === 'on'))
  }

  /*
   emailResultObj = {
   infoText: string, // Present only if error message is available
   emailQueued: string // 'true' or 'false'
   }
   */
  const apiEventEmailResult = () => {}

  /*
   noSessionObj = { infoText: string}
   */
  const apiEventNoSession = () => {}

  const eventCallbacks = {
    ready: apiEventReady,
    config: apiEventConfig,
    startup: apiEventStartup,
    entranceClosed: apiEventEntranceClosed,
    queue: apiEventQueue,
    placedInQueue: apiEventPlacedInQueue,
    established: apiEventEstablished,
    chatEntry: apiEventChatEntry,
    penStatus: apiEventPenStatus,
    messageSent: apiEventMessageSent,
    afterChat: apiEventAfterChat,
    emailResult: apiEventEmailResult,
    finished: apiEventFinished,
    error: apiEventError,
    noSession: apiEventNoSession,
    clear: apiEventClear,
  }

  const requestCallbacks = {
    startChat,
    showChat,
    hideChat,
  }

  if (!getState().chat.apiInitialized) {
    log('CallGuide API not initialized, initializing now!')
    CallGuide.api.chat.initialize(
      eventCallbacks,
      requestCallbacks,
      '#chatMessage',
    )

    dispatch(apiInitialized())
  }
}

const getChatToken = customerData => dispatch => {
  return dispatch(
    request(authServiceApi.getChatToken, {
      ...Object.fromEntries(customerData),
    }),
  )
    .then(data => {
      dispatch(chatTokenSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const openChatForm = () => dispatch => {
  dismiss('chatCallToAction')
  dispatch(chatFormOpened())
}

export const showOpeningHours = () => dispatch => {
  dispatch(chatEntranceClosed())
}

export const requestChat = chatRequest => (dispatch, getState) => {
  initializeApi()

  const country = getState().storeInfo.currentRepresentative.country

  const entrance =
    config.chatEnvironment === 'prod' ? chatEntrance[country] : 'ChatTestEnv'

  const {
    payApply: {
      application: { applicationResult },
      payment: { paymentResult },
      current,
    },
    auth: { me },
    router: {
      location: { pathname },
    },
  } = getState()
  const selectedLimit =
    current?.selectedLimit > 0 ? current?.selectedLimit : undefined
  const customerData = new Map(
    pathname.includes('apply')
      ? [
          ['governmentId', current?.governmentId ?? undefined],
          ['mobileNumber', me?.phoneNumber ?? undefined],
          ['selectedLimit', selectedLimit],
          [
            'mupId',
            applicationResult?.application?.mupId ??
              paymentResult?.application?.mupId ??
              undefined,
          ],
        ]
      : [],
  )
  dispatch(getChatToken(customerData)).then(() => {
    const contactData = {}
    const authToken = getState().chat.token
    startChat(
      entrance,
      chatRequest.type,
      chatRequest.msg.text,
      contactData,
      authToken,
    )
  })
  dispatch(chatRequestedSuccess(chatRequest.type))
}
